(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-description"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initScrollReveal() {
      const containers = document.querySelectorAll('[data-scroll-reveal]');
      containers.forEach(function(container) {
        if (container.dataset.scrollRevealInitialized) return;
        container.dataset.scrollRevealInitialized = 'true';

        const rawText = container.textContent.trim();
        if (!rawText) return;

        const words = rawText.split(/\s+/);
        container.innerHTML = '';

        words.forEach(function(word) {
          const span = document.createElement('span');
          span.className = 'series-description__word series-description__word--dimmed';
          span.textContent = word + ' ';
          container.appendChild(span);
        });

        const wordElements = container.querySelectorAll('.series-description__word');

        function handleScroll() {
          const wrapper = container.closest('[data-reveal-completion]');
          const completionPct = parseFloat(wrapper?.dataset.revealCompletion || 35);
          console.log('completionPct', completionPct);
          const completionFactor = Math.max(0.1, Math.min(1, completionPct / 100));

          const rect = container.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          const revealStart = windowHeight * 0.85;
          const revealEnd = windowHeight * 0.50;
          const scrollRange = revealStart - revealEnd + rect.height * completionFactor;
          let progress = (revealStart - rect.top) / scrollRange;
          progress = Math.max(0, Math.min(1, progress));
          const wordsToReveal = Math.floor(progress * wordElements.length);

          wordElements.forEach(function(el, index) {
            el.classList.toggle('series-description__word--dimmed', index >= wordsToReveal);
          });
        }

        window.addEventListener('scroll', function() {
          requestAnimationFrame(handleScroll);
        }, { passive: true });
        handleScroll();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollReveal);
    } else {
      initScrollReveal();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
